"use client";

import { LOCALE_NAMES } from "../const/i18n";
import { useLocale } from "../context/i18n";

// The empty captions track the marketing videos carry, for the a11y audit. These
// videos have no speech to caption.
export default function EmptyCaptionsTrack() {
  const lang = useLocale();
  return (
    <track
      kind="captions"
      srcLang={lang}
      label={LOCALE_NAMES[lang]}
      src="/captions/empty.vtt"
      default
    />
  );
}
